export enum LockApplicationType {
  Desktop = 0,
  Web = 1
}